import { createAction } from 'redux-act'

import { Notification, PublicProfilePageResponse } from '../types'

const addNotification = createAction<Notification>('profile - add notification')
const resetNotifications = createAction('profile - reset notifications')

const fetchPublicProfilePageStart = createAction('profile - fetch public styleboards start')
const fetchPublicProfilePageSuccess = createAction<PublicProfilePageResponse>(
  'profile - fetch public styleboards success',
)
const fetchPublicProfilePageFail = createAction<Error>('profile - fetch public styleboards fail')
const fetchPublicProfilePageSuccessNoContent = createAction(
  'profile - fetch public styleboards succes no content',
)

export default {
  addNotification,
  resetNotifications,
  fetchPublicProfilePageStart,
  fetchPublicProfilePageSuccess,
  fetchPublicProfilePageSuccessNoContent,
  fetchPublicProfilePageFail,
}
